// extracted by mini-css-extract-plugin
export default {"labelText":"LoyaltyRegistrationButton_labelText__dmo8J","link":"LoyaltyRegistrationButton_link__MTpq_"};